import React from "react";
import {
  BoxWrapper,
  OptBox,
  Option,
  SocialBox,
  Title,
  SocialWrapper,
  PhoneText,
  SocialLink,
  More,
} from "../Message.style";
import { useEffect } from "react";
import { api } from "@api";
import { useState } from "react";
import { useSelector } from "react-redux";
import { CHINESE_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";
import { Col } from "antd";
import {
  FacebookFilled,
  ViberFilled,
  YoutubeFilled,
  TelegramFilled,
  PhoneFilled,
} from "@assets";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { getFingerprintData } from "@utils";
import { MESSAGE_TYPES } from "@constants";

const { AUTO_REPLY } = MESSAGE_TYPES;

const OptionBox = ({
  room_id,
  loadingCallback,
  errorCallback,
  scrollToBottom,
  resetTempData,
  sendOptionSuccessCallback,
}) => {
  const { t } = useTranslation();
  const {
    userPreferedLanguage,
    settings: { social_links },
  } = useSelector((state) => state.app);
  const { user_id } = useSelector((state) => state.auth.user);
  const [options, setOptions] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getMessageOptions();

    // eslint-disable-next-line
  }, []);

  const getMessageOptions = () => {
    api
      .getMessageOptions()
      .then(({ message_options }) => {
        setOptions(message_options);
      })
      .catch(() => { });
  };

  const doPost = (payload, item) => {
    resetTempData();
    getFingerprintData()
      .then(device_info => {
        api
          .postMessage({
            ...payload,
            room_id,
            device_info,
          })
          .then(({ messages }) => {
            const sent_msg = { ...messages[0], uuid: item.uuid };
            if (payload.type === AUTO_REPLY) {
              const reply_msg = messages[1];
              sendOptionSuccessCallback({ reply_msg, sent_msg });
            }
          })
          .catch(() => {
            errorCallback(item);
          });
      })
      .catch(() => { });
  };

  const sendOption = ({ content, message_option_id }) => {
    const payload = {
      type: AUTO_REPLY,
      message_option_id,
      content,
    };
    let item = makeTempItem(payload);
    loadingCallback(item);
    doPost(payload, item);
    scrollToBottom();
  };

  const makeTempItem = (msg) => {
    return {
      ...msg,
      sender_id: user_id,
      sent_at: moment().unix(),
      loading: true,
      uuid: uuidv4(),
    };
  };

  const getLangMsg = (opt) => {
    return userPreferedLanguage === CHINESE_LANGUAGE_CODE_LK
      ? opt.button_text_ch
      : userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK
        ? opt.button_text_mm
        : opt.button_text_en;
  };

  const Link = ({ url, children }) => (
    <SocialLink href={url} target="_blank" rel="noreferrer noopen">
      {children}
    </SocialLink>
  );

  return (
    <>
      <BoxWrapper>
        <OptBox more={open}>
          {options.map((opt, key) => {
            if (open) {
              return (
                <Col key={key}>
                  <Option
                    key={key}
                    onClick={() =>
                      sendOption({
                        content: getLangMsg(opt),
                        message_option_id: opt.message_option_id,
                      })
                    }
                  >
                    {getLangMsg(opt)}
                  </Option>
                </Col>
              );
            } else {
              if (key < 5) {
                return (
                  <Col key={key}>
                    <Option
                      key={key}
                      onClick={() =>
                        sendOption({
                          content: getLangMsg(opt),
                          message_option_id: opt.message_option_id,
                        })
                      }
                    >
                      {getLangMsg(opt)}
                    </Option>
                  </Col>
                );
              } else {
                return null;
              }
            }
          })}
          <Col>
            {options.length > 5 && (
              <More style={{}} onClick={() => setOpen((prev) => !prev)}>
                {open
                  ? `-${t("message.showLessLabel")}`
                  : `+${t("message.showMoreLabel")}`}
              </More>
            )}
          </Col>
        </OptBox>
        <SocialBox>
          <SocialWrapper>
            <Title>{t("home.appDownloadSubTitle1")}</Title>
            <div>
              <Link url={social_links.fb_link}>
                <FacebookFilled />
              </Link>
              <Link url={social_links.viber_link}>
                <ViberFilled />
              </Link>
              <Link url={social_links.telegram_link}>
                <TelegramFilled />
              </Link>
              <Link url={social_links.youtube_link}>
                <YoutubeFilled />
              </Link>
            </div>
          </SocialWrapper>
          <SocialWrapper>
            <Title>{t("home.appDownloadSubTitle1")}</Title>
            <div>
              <a href={`tel:${social_links.phones[0]}`}>
                <PhoneText size={"small"}>
                  <PhoneFilled style={{ height: 16, width: 16 }} />
                  {social_links.phones[0]}
                </PhoneText>
              </a>
              <a href={`tel:${social_links.phones[1]}`}>
                <PhoneText size={"small"}>
                  <PhoneFilled style={{ height: 16, width: 16 }} />
                  {social_links.phones[1]}
                </PhoneText>
              </a>
            </div>
          </SocialWrapper>
        </SocialBox>
      </BoxWrapper>
      {/* <OptionsDrawer
        options={options}
        open={open}
        handleClose={handleClose}
        sendOption={sendOption}
        getLangMsg={getLangMsg}
      /> */}
    </>
  );
};

export default OptionBox;
